import { createRouter, createWebHistory } from "vue-router"
import Home from "../views/Home.vue"
import News from "../views/News.vue"

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/news",
    name: "News",
    props: true,
    component: News
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: import(/*webpackChunkName: '404' */ "@/views/Error404.vue"),
  },
]

const router = new createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes,
})

export default router
